import { rotateDegVector2d } from "./vector.js";
import "../decorators/type.js";
import "ajv";
import "./clone.js";
import "bitecs";
import "./typehelpers.js";
import "../enums-86f58524.js";
import "../global-33d5eebf.js";
const toWorldSpace = (position) => {
  const transformedPosition = rotateDegVector2d(position, 45);
  transformedPosition.x *= Math.SQRT2;
  transformedPosition.y *= 0.5 * Math.SQRT2;
  return transformedPosition;
};
export {
  toWorldSpace
};
//# sourceMappingURL=isometric.js.map
